import { createReducer, on } from '@ngrx/store';
import { getCartSummarySuccess, getNewCartIDReceived, removeCartInfo } from 'src/app/feature/cart/redux/cart.actions';
import { CartState, initialState } from 'src/app/feature/cart/redux/cart.state';
import { clearUserAction, logout } from '../../../core/user/user.actions';

const onGetNewCartIDReceived = on(getNewCartIDReceived, (state: CartState, action) => {
	return {
		...state,
		cart: {
			cartId: action.cartId,
			cartKey: action.cartKey,
		},
	};
});

const onGetCartSummarySuccess = on(getCartSummarySuccess, (state: CartState, action) => {
	return {
		...state,
		summary: action.summary,
	};
});

const onLogout = on(logout, clearUserAction, removeCartInfo, (state: CartState, action) => ({
	cart: null,
	summary: null,
}));

export const cartReducer = createReducer(initialState, onGetNewCartIDReceived, onGetCartSummarySuccess, onLogout);
